import React from 'react';
import { connect } from 'react-redux';

import { addParamsToUrl } from '@zapier/url-utils';

import LoadingBlock from 'app/common/components/LoadingBlock';
import SplitLoginPageWrapper from 'app/login/components/SplitLoginPageWrapper';
import { selectSelectedApis } from 'app/login/Selectors';
import {
  getCurrentPathname,
  getQueryParam,
  getQueryParams,
} from 'app/common/utils/RouterSelectors';

import WithInvitationByCode from './WithInvitationByCode';

export const mapStateToProps = (state, props) => {
  const next = getQueryParam(state, 'next');
  const selectedApis = selectSelectedApis(state);
  const path = getCurrentPathname(state);

  const isZt = next && next.indexOf('/app/editor/template/') === 0;
  const isLogin = path.indexOf('/app/login') === 0;
  const invitationCode = getQueryParam(state, 'invitation');
  const isInvitation = !!invitationCode;
  const isTeamMemberInvitation = path.includes('/team-member/');
  const isOneService = selectedApis.length === 1;
  const isTwoService = selectedApis.length > 1;

  const topLink =
    path.indexOf('/sign-up') === 0
      ? {
          text: 'Log In',
          href: addParamsToUrl('/app/login/', getQueryParams(state)),
        }
      : {
          text: 'Sign Up',
          href: addParamsToUrl('/sign-up/', getQueryParams(state)),
        };

  return {
    invitationCode,
    isZt,
    isLogin,
    isInvitation,
    isTeamMemberInvitation,
    isOneService,
    isTwoService,
    selectedApis,
    topLink,
    ...props,
  };
};

const SplitLoginPageWrapperContainer = props => {
  return (
    <WithInvitationByCode code={props.invitationCode}>
      {invitation => {
        if (invitation.isLoading || props.isLoading) {
          return <LoadingBlock />;
        }

        return (
          <SplitLoginPageWrapper
            {...props}
            accountName={invitation.accountName}
            teamLogoUrl={invitation.teamLogoUrl}
          />
        );
      }}
    </WithInvitationByCode>
  );
};

export default connect(mapStateToProps)(SplitLoginPageWrapperContainer);
